module.exports = __webpack_public_path__ + "static/media/dermoglam.b5ca59c1.jpg";